<template>
  <div class="subject">
    <img
      v-if="name === `math`"
      class="subject__image"
      src="@/assets/practices/global/subject/math.svg"
      alt="subject_math"
    />
    <!-- Use this template to add more subjects. -->
    <!-- <img class="subject__image" v-else-if="name === `SUBJECT_GOES_HERE`" src="PATH_GOES_HERE" alt="ALT_GOES_HERE" /> -->
  </div>
</template>

<script>
export default {
  name: 'Subject',
  props: {
    // eslint-disable-next-line vue/require-default-prop
    name: String,
  },
};
</script>

<style lang="scss" scoped>
.subject {
  align-items: center;
  display: flex;
  justify-content: center;
  left: 0;
  position: absolute;
  top: 0;
  z-index: 100;

  &__image {
    height: 12.5vh;
  }
}
</style>
